"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var animate_scss_1 = tslib_1.__importDefault(require("./animate.scss"));
var withStyles_1 = require("../../utils/withStyles");
var Animate = /** @class */ (function (_super) {
    tslib_1.__extends(Animate, _super);
    function Animate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animate.prototype.render = function () {
        var _a, _b;
        var _c = this.props, _d = _c.type, type = _d === void 0 ? 'fade-in' : _d, children = _c.children, when = _c.when, className = _c.className, _e = _c.activeClassName, activeClassName = _e === void 0 ? '' : _e, dataHook = _c.dataHook;
        if (!children) {
            return null;
        }
        var classNames = classnames_1.default(className, (_a = {}, _a[activeClassName] = when, _a), animate_scss_1.default[type], (_b = {}, _b[animate_scss_1.default.active] = when, _b));
        return (react_1.default.createElement("div", tslib_1.__assign({}, (dataHook && when && { 'data-hook': dataHook }), { className: classNames, "aria-hidden": !when }), children));
    };
    Animate = tslib_1.__decorate([
        withStyles_1.withStyles(animate_scss_1.default)
    ], Animate);
    return Animate;
}(react_1.default.Component));
exports.default = Animate;
//# sourceMappingURL=animate.js.map